import React from 'react';
const ButtonWrapper = ({ badge, children, extraClass, }) => {
    return (React.createElement("div", { className: "th-c-button-wrapper" },
        badge && React.createElement("span", { className: `th-c-button-wrapper__badge ${extraClass}` }, badge),
        children));
};
export default ButtonWrapper;
